import classNames from 'classnames'
import * as React from 'react'

import { Button } from 'components/Button'
import Icon from 'components/Icon'
import { UI } from 'Icon/ui'
import { DefaultContent } from 'react-content-engine'

import './ActionList.scss'

interface ActionListItemProps {
  icon: JSX.Element
  subject: string | JSX.Element
  value: string | JSX.Element
  subValue?: string | JSX.Element
  overrideEdit?: string | JSX.Element
  locked?: boolean
  listItemClass?: string
  onClick?: () => void
  iconProps?: object
}

interface ActionListProps {
  children?: React.ReactNode | undefined
  listClass?: string
}

const ActionList: React.FC<ActionListProps> = props => {
  return <ul className={classNames(`srprs-action-list`, props.listClass && props.listClass)}>{props.children}</ul>
}

const ActionListItem: React.FC<ActionListItemProps> = props => {
  const className = classNames('srprs-list-item', props.locked && 'locked', props.listItemClass && props.listItemClass)
  return (
    <li className={className} onClick={props.onClick}>
      <Icon icon={props.icon} {...props?.iconProps} />
      <div>
        <span>{props.subject}</span>
        <span>
          <strong> {props.value}</strong>
          <span className={'sub-value'}>{props.subValue}</span>
        </span>
      </div>
      {props.overrideEdit ? (
        <div className="override">{props.overrideEdit}</div>
      ) : (
        <Button cutOff={'none'}>
          <i>
            <DefaultContent contentKey="edit">Edit</DefaultContent>
          </i>
          <Icon icon={UI.pencil} />
        </Button>
      )}
    </li>
  )
}

export { ActionList, ActionListItem }
